import {
  Block,
  LabelXSmall,
  Link,
  LinkProps,
  useStyletron,
} from "@mezo-org/mezo-clay"
import { useLocalStorage } from "usehooks-ts"

import { links, LOCAL_STORAGE_QA_MODE, QA_MODE } from "#/shared/constants"

const FOOTER_NAVIGATION: LinkProps[] = [
  {
    children: "Terms of Service",
    href: links.TERMS_OF_USE,
  },
  {
    children: "FAQ",
    href: links.MEZO_FAQ,
  },
  {
    children: "Support ",
    href: links.DISCORD_SUPPORT,
  },
  {
    children: "Mezo Docs",
    href: links.DOCS,
  },
]

export default function DashboardFooter() {
  const [css, theme] = useStyletron()

  const [_, setQaMode] = useLocalStorage<boolean>(
    LOCAL_STORAGE_QA_MODE,
    QA_MODE,
  )

  return (
    <Block
      as="footer"
      className={css({
        height: "113px",
        padding: theme.sizing.scale800,
        paddingLeft: theme.sizing.scale1600,
        display: "flex",
        alignItems: "center",
        gap: theme.sizing.scale700,
      })}
    >
      {FOOTER_NAVIGATION.map((props) => (
        <Link
          key={props.href}
          size="xsmall"
          target="_blank"
          className={css({
            ":visited": {
              color: theme.colors.black,
            },
          })}
          {...props}
        />
      ))}
      {/* 
        To be able to see QA related featrues like additional data and tooltips
        we use this text in the footer to enable the special mode even on 
        production environment.
      */}
      <LabelXSmall onDoubleClick={() => setQaMode((isEnabled) => !isEnabled)}>
        ©️ 2025 Thesis
      </LabelXSmall>
    </Block>
  )
}
